<template>
  <div id="banner" class="ut-bg-green-500 ut-p-2 ut-mb-5 ut-justify-around">
    <p class="ut-pl-3 md:ut-text-center ut-text-neutral-001 ut-m-auto banner">
      <!-- Hard coded text to be moved to parent component -->
      Enrich your listing experiences with OpenAgent 3D virtual property tours - <a class="ut-font-bold ut-underline" :href="href" target="_blank" @click="gaEvent()">LEARN MORE</a>
      <img src="@/assets/styles/frontend-library/images/close-white.svg"
          alt="OpenAgent" width="16" class="ut-float-right" @click="closeBanner" />
    </p>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    href: {
      type: String,
      required: false,
    },
    gaTracking: {
      type: Boolean,
      required: false,
      default: true,
    },
    gacategory: {
      type: String,
      required: false,
      default: 'Agent Portal Upsell Banner',
    },
    gaaction: {
      type: String,
      required: false,
      default: 'Click LEARN MORE',
    },
    galabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
  },
  methods: {
    closeBanner() {
      this.$emit('close');
      this.$helpers.gaEvent(this.gacategory, 'Click Close', this.galabel);
    },
    gaEvent() {
      if (this.gaTracking) {
        this.$helpers.gaEvent(this.gacategory, this.gaaction, this.galabel);
      }
    },
  }
};
</script>

<style scoped lang="scss">

.banner {
  line-height: 22px;
}

</style>
